/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Aggregator } from '../../models/aggregator';

export interface AggregatorsAggregatorIdGet$Params {
  aggregatorId: string;
}

export function aggregatorsAggregatorIdGet(http: HttpClient, rootUrl: string, params: AggregatorsAggregatorIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Aggregator>> {
  const rb = new RequestBuilder(rootUrl, aggregatorsAggregatorIdGet.PATH, 'get');
  if (params) {
    rb.path('aggregatorId', params.aggregatorId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Aggregator>;
    })
  );
}

aggregatorsAggregatorIdGet.PATH = '/aggregators/{aggregatorId}';
